import BoothSetup from './BoothSetup';

export default BoothSetup;
